import { doc, getDoc, getDocs, setDoc, collection, updateDoc, query, where } from "firebase/firestore";
// import db_firestore from '../../firebase/config.js'
import firebase, { auth, db_firestore } from "../../firebase/config";

export const fetchOrganizationInfo = item => {
    return async (dispatch, getState, { getFirebase }) => {
       // get tenant_id
        const state = getState();
        const tenant_id = auth.currentUser.tenantId
        console.log('[FETCH_ORG_INFO]: ', tenant_id)
        const orgRef = collection(db_firestore, "organization");
        // create a query against the collection.
        const q = query(orgRef, where("organization_info.tenant_id", "==", tenant_id));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            console.log('[FETCH_ORG_INFO] - RESULTS: ', doc.data())
            dispatch({ type: "FETCH_ORG_INFO", payload: doc.data()});
          });
    };
  };